import { COOKIE_KEY_COOKIE_CONSENT } from '@application/constants';
import { clearCookieFromAllPathsAndDomains, cookies, useModal } from '@application/utils';
import { CookiesBanner } from '@presentation/components';
import dayjs from 'dayjs';
import { useCallback, useEffect, useMemo, useState } from 'react';
import {
  CookiePreferencesModalController,
  useCookiePreferencesModal,
} from '../CookiePreferencesModalController';

export const CookiesBannerController = () => {
  const [shown, setShown] = useState(false);

  const {} = useModal();
  const { show } = useCookiePreferencesModal();

  const shouldShow = useMemo((): boolean => {
    if (typeof document === 'undefined') return false;
    const cookieConsent = cookies.get(COOKIE_KEY_COOKIE_CONSENT);
    // Condition to invalidate old users cookies
    if (cookieConsent === 'true') {
      clearCookieFromAllPathsAndDomains(COOKIE_KEY_COOKIE_CONSENT);
    }
    if (!['11', '10'].includes(cookieConsent)) return true;
    return false;
  }, []);

  const acceptClickHandler = useCallback(() => {
    const expirationDate = dayjs().add(1, 'year').toDate();
    if (typeof document !== 'undefined') {
      document.cookie = `${COOKIE_KEY_COOKIE_CONSENT}=11; expires=${expirationDate.toUTCString()}; path=/`;
      window.gtag('consent', 'update', {
        analytics_storage: 'granted',
        ad_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted',
      });
    }

    setShown(false);
  }, []);

  const customizeClickHandler = useCallback(() => {
    show();
  }, [show]);

  useEffect(() => {
    if (shouldShow) {
      setTimeout(() => {
        setShown(true);
      }, 10);
    }
  }, [shouldShow]);

  return (
    <>
      <CookiePreferencesModalController
        closeCookieBanner={() => {
          setShown(false);
        }}
      />
      {shown ? (
        <CookiesBanner
          onAcceptClick={acceptClickHandler}
          onCustomizeClick={customizeClickHandler}
        />
      ) : null}
    </>
  );
};
